import createPasswordFailure from './createPassword/failure';
import createPasswordRequest from './createPassword/request';
import createPasswordSuccess from './createPassword/success';
import editFailure from './edit/failure';
import editRequest from './edit/request';
import editSuccess from './edit/success';
import editCompanyFailure from './editCompany/failure';
import editCompanyRequest from './editCompany/request';
import editCompanySuccess from './editCompany/success';
import forgotPasswordFailure from './forgotPassword/failure';
import forgotPasswordRequest from './forgotPassword/request';
import forgotPasswordSuccess from './forgotPassword/success';
import logoutRequest from './logout/request';
import setProfile from './profile/set';
import resetPasswordFailure from './resetPassword/failure';
import resetPasswordRequest from './resetPassword/request';
import resetPasswordSuccess from './resetPassword/success';
import setToken from './set/token';
import signInFailure from './signIn/failure';
import signInRequest from './signIn/request';
import signInSuccess from './signIn/success';

const reducers = {
  editFailure,
  editRequest,
  editSuccess,
  forgotPasswordFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  logoutRequest,
  resetPasswordFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  editCompanyFailure,
  editCompanyRequest,
  editCompanySuccess,
  setProfile,
  setToken,
  signInFailure,
  signInRequest,
  signInSuccess,
  createPasswordFailure,
  createPasswordRequest,
  createPasswordSuccess,
};

export default reducers;
